import { shallow } from 'zustand/shallow';
import { CasinoTypeUnion } from '../../../types';
import { useGamesStore } from '../../store';

export const useGetLobby = (casinoType: CasinoTypeUnion) => {
  return useGamesStore((store) => store.lobbies[casinoType] || {}, shallow);
};
